export default {
  login: "/login",
  logout: "/logout",

  signUpOnboarding: "/signup-onboarding",

  old: {
    home: "/dashboard/library",
    assessments: "/dashboard/assessments",
    assignments: "/dashboard/assignments",
    payment: "/dashboard/orders/payment",
    orders: "/dashboard/orders",
    ito: "/dashboard/ito",
  },

  claimSuraasaPlus: "/claim-suraasa-plus",

  suraasaPlus: {
    payment: "/payment/suraasa-plus-new-year",
    paymentSuccess: "/payment/suraasa-plus-new-year/success",
    questionnaireOnboarding: "/suraasa-plus-new-year/questionnaire-onboarding",
  },

  maintenance: "/maintenance",

  skillProfile: {
    public: "/profile/skill-profile/:username?",
    asCentre: "/centre/profile/skill-profile/:username",
    asSchool: "/school/profile/skill-profile/:username",
    asRecruiter: "/recruiter/profile/skill-profile/:username",
  },

  profile: {
    self: "/profile",
    edit: "/profile/edit",
    public: "/profile/:username",

    asCentre: "/centre/profile/:username",
    asSchool: "/school/profile/:username",
    asRecruiter: "/recruiter/profile/:username",
  },

  ito2022: "/past-events/international-teachers-olympiad-2022",
  ito: "/international-teachers-olympiad",
  tia: "/teacher-impact-awards",

  cpat: {
    dashboard: "/cpat",
    payment: "/cpat/payment",
    paymentWithoutSignin: "/cpat/payment/direct",
    attempt: "/cpat/attempt/:attemptId",
    tutorial: "/cpat/attempt/tutorial",
    proctoringReport: "/cpat/proctoring-report/:attemptId",
  },

  notifications: "/notifications",

  learnerHandbook: "/pgctl-learner-handbook",
  medStudentCatalog: "/med-student-catalog",

  home: "/home",
  learning: "/learning",
  certificates: "/certificates",
  mySchedule: "/my-schedule",
  masterclasses: "/masterclasses",
  viewMasterclass: "/masterclasses/:slug",

  discussions: "/learning/discussions",
  discussionDetail: "/learning/discussions/:id",

  applicationForm: {
    uploadPgctlDocuments: "/application-form/pgctl/upload-documents",
  },

  // Learning Module Routes
  learningModule: "/learning/course/:slug",
  learningModuleWithParent:
    "/learning/:learningItemType/:parentSlug/course/:slug",

  // Course Routes
  course: "/course/:slug",
  courseAssignments: "/course/:slug/assignments",
  scheduleInterview: "/application-form/schedule-interview",

  // Qualification Routes
  parentItem: "/:learningItemType/:slug",
  parentItemCourse: "/:learningItemType/:parentSlug/course/:slug",
  parentItemOverview: "/:learningItemType/:slug/overview",
  parentItemAssessments: "/:learningItemType/:slug/assessments",
  parentItemCertificates: "/:learningItemType/:slug/certificates",
  parentItemResources: "/:learningItemType/:slug/resources",
  parentItemClasses: "/:learningItemType/:slug/classes",
  parentItemAnalytics: "/:learningItemType/:slug/analytics",

  parentItemGradebook: "/:learningItemType/:slug/gradebook",
  parentItemLeaderboard: "/:learningItemType/:slug/leaderboard",
  parentItemAbout: "/:learningItemType/:slug/about",

  // Assessment Routes
  attemptAssessment: "/assessments/attempt/:assessmentId",
  assessmentResult: "/assessments/result/:attemptId",
  instructionsITOAssessment:
    "/ito/assessments/instructions/:assessmentId/:attemptId?",
  attemptITOAssessment: "/ito/assessments/attempt/:attemptId",

  // Assignment Routes
  assignment: "/:learningItemType/:slug/assignments/:assignmentId",
  submission:
    "/:learningItemType/:slug/assignments/:assignmentId/:submissionId",

  // Orders Routes
  orders: "/orders",
  orderDetailsPage: "/orders/:id",
  orderPaymentPlan: "/orders/:id/payment-plan",

  payment: "/orders/payment",
  retryPayment: "/orders/payment/retry",
  subscription: "/orders/payment/subscription",

  // Settings Routes
  settings: "/settings",
  privacy: "/settings/privacy",
  accountDetails: "/settings/account-details",
  cleverAccountLinkCallback: "/settings/account-details/clever-callback",
  notificationSettings: "/settings/notifications",
  suraasaPlusSettings: "/settings/suraasa-plus",
  suraasaPlusPaymentHistory: "/settings/suraasa-plus/payment-history",
  suraasaPlusCompareFeat: "/settings/suraasa-plus/compare-features",

  misc: {
    components: "/misc/components",
    proctoringDemo: "/testing/proctoring-start-assessment/",
    browserInfo: "/browser-info",
    fillBlanksTest: "/misc/fill-blanks-test",
  },

  aiTools: {
    home: "/ai-tools",
    lessonPlan: "/ai-tools/lesson-plan/",
    rubrics: "/ai-tools/rubrics/",
    quiz: "/ai-tools/quiz/",
    handout: "/ai-tools/handout/",
    narration: "/ai-tools/narration/",
    subjectiveAssessment: "/ai-tools/subjective-assessment/",
    assignment: "/ai-tools/assignment/",
    activityPlanner: "/ai-tools/activity-planner/",
    videoSummary: "/ai-tools/video-summary/",
    unitPlanner: "/ai-tools/unit-planner/",
  },

  pgctlOnboarding: {
    payment: "/payment/registration-fee",
  },

  embeddedPayment: "/payment/embedded/suraasa-sure",

  embeddedGoogleForm: "/egf",

  gsgCpat: "/gsg/cpat/:slug",
}

type GetRouteParams<T extends string> =
  T extends `${infer _start}:${infer Param}/${infer rest}`
    ? Param | GetRouteParams<`/${rest}`>
    : T extends `${infer _start}:${infer Param}`
    ? Param
    : never

type RouteParams<T extends string> = {
  [K in GetRouteParams<T>]: string
}
export const routeBuilder = <T extends string>(
  route: T,
  params: RouteParams<T>,
  queryParams?: Record<string, string | number>
): string => {
  let r = route as string
  for (const key in params) {
    r = r.replace(`:${key}`, params[key as keyof typeof params])
  }

  if (queryParams) {
    const searchParams = new URLSearchParams()
    Object.entries(queryParams).forEach(([key, value]) => {
      searchParams.append(key, value.toString())
    })
    r += `?${searchParams.toString()}`
  }

  return r
}
